import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-approved-renderer',
  templateUrl: './approved-renderer.component.html',
  styleUrls: ['./approved-renderer.component.scss']
})
export class ApprovedRendererComponent implements ICellRendererAngularComp {
  params: any;
 isActive: boolean = false;

  constructor() { }

  agInit(params: ICellRendererParams<any, any>): void {
    this.params = params;
    this.isActive = !!params.value;
  }
  refresh(params: ICellRendererParams<any, any>): boolean {
    return false
  }

  onToggleChange(isActive: boolean) {
    // this.isActive = isActive;

    const customEvent = new CustomEvent('toggleApproveChange', {
      detail: { data: this.params.data, isActive: isActive }
    });
    document.dispatchEvent(customEvent);
  }
}
